module.exports = __webpack_public_path__ + "static/will-72885ed794251cbedf4c24e2f10bf52e.jpg";